<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<ThePageLoading v-if="isPageLoading"></ThePageLoading>
					
					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader @delete-event="deleteCompany" :renderDelete="(identifier != null ? true : false)" :isDeleting="isDeleting"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							<div class="col-md-12 p-4">	
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Name:</label>
									</div>
												
									<div class="col-md-6">
										<InputText class="p-inputtext" type="text" maxlength="100" placeholder="Name" v-model="eliminationSetting.name" />
									</div>
								</div>

                                <div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Exchange Rate:</label>
									</div>
												
									<div class="col-md-6">
										<Dropdown :options="exchangeRate" optionLabel="name" optionValue="value" placeholder="-- Please Select --" v-model="eliminationSetting.exchangeRate" />
									</div>
								</div>

                                <div class="row mb-4">
									<div class="col-md-3">
										<label class="col-form-label-title">Create Elimination Report tab: </label>
									</div>
												
									<div class="col-md-6 pt-1">
										<Checkbox v-model="eliminationSetting.isAssociated" :binary="true" />
									</div>
								</div>

                                <div class="row mb-3">
									<Divider>
										<b>Columns</b>
									</Divider>
								</div>

                                <div class="row mb-4">
									<div class="col-md-6 required">
										<label class="col-form-label-title">Debit Sheet</label>
									</div>

                                    <div class="col-md-6 required">
										<label class="col-form-label-title">Credit Sheet</label>
									</div>
								</div>

                                <div class="row mb-4">
									<div class="col-md-6">
										<Dropdown v-model="eliminationSetting.rpkDebitSheet" :options="sheets.filter((s: any) => s.type == 'RPK')" placeholder="Select a Sheet" filter :filterFields="['code', 'name']" showClear optionLabel="code">
                                            <template #value="dropdownProps">
                                                <div v-if="dropdownProps.value" class="flex align-items-center">
                                                    <div class="row">
                                                        <span class="col-md-3">{{ dropdownProps.value.code }}</span>
                                                        <span class="col-md-9">{{ dropdownProps.value.name }}</span>
                                                    </div>
                                                </div>

                                                <span v-else>
                                                    {{ dropdownProps.placeholder }}
                                                </span>
                                            </template>

                                            <template #option="dropdownProps">
                                                <div v-if="!checkRpkCreditSheetExist(dropdownProps)" class="row">
                                                    <span class="col-md-3">{{ dropdownProps.option.code }}</span>
                                                    <span class="col-md-9">{{ dropdownProps.option.name }}</span>
                                                </div>

												<span v-else class="sheet-option-pair"></span>
                                            </template>
                                        </Dropdown>
									</div>

                                    <div class="col-md-6">
										<Dropdown v-model="eliminationSetting.rpkCreditSheet" filter :filterFields="['code', 'name']" showClear optionLabel="code" :options="sheets.filter((s: any) => s.type == 'RPK')" placeholder="Select a Sheet" >
                                            <template #value="dropdownProps">
                                                <div v-if="dropdownProps.value" class="flex align-items-center">
                                                    <div class="row">
                                                        <span class="col-md-3">{{ dropdownProps.value.code }}</span>
                                                        <span class="col-md-9">{{ dropdownProps.value.name }}</span>
                                                    </div>
                                                </div>

                                                <span v-else>
                                                    {{ dropdownProps.placeholder }}
                                                </span>
                                            </template>

                                            <template #option="dropdownProps">
                                                <div v-if="!checkRpkDebitSheetExist(dropdownProps)" class="row">
                                                    <span class="col-md-3">{{ dropdownProps.option.code }}</span>
                                                    <span class="col-md-9">{{ dropdownProps.option.name }}</span>
                                                </div>

												<span v-else class="sheet-option-pair"></span>
                                            </template>
                                        </Dropdown>
									</div>
								</div>
									
								<div class="row mb-3">
									<Divider>
										<b>CWK Debit/Credit Amounts</b>
									</Divider>
								</div>

                                <div class="row mb-4">
									<div class="col-md-6 required">
										<label class="col-form-label-title">Debit Sheet</label>
									</div>

                                    <div class="col-md-6 required">
										<label class="col-form-label-title">Credit Sheet</label>
									</div>
								</div>

                                <div class="row mb-4">
									<div class="col-md-6">
										<Dropdown v-model="eliminationSetting.cwkDebitSheet" :options="sheets.filter((s: any) => s.type == 'CWK')" placeholder="Select a Sheet" filter :filterFields="['code', 'name']" showClear optionLabel="code">
                                            <template #value="dropdownProps">
                                                <div v-if="dropdownProps.value" class="flex align-items-center">
                                                    <div class="row">
                                                        <span class="col-md-3">{{ dropdownProps.value.code }}</span>
                                                        <span class="col-md-9">{{ dropdownProps.value.name }}</span>
                                                    </div>
                                                </div>

                                                <span v-else>
                                                    {{ dropdownProps.placeholder }}
                                                </span>
                                            </template>

                                            <template #option="dropdownProps">
                                                <div class="row">
                                                    <span class="col-md-3">{{ dropdownProps.option.code }}</span>
                                                    <span class="col-md-9">{{ dropdownProps.option.name }}</span>
                                                </div>
                                            </template>
                                        </Dropdown>
									</div>

                                    <div class="col-md-6">
										<Dropdown v-model="eliminationSetting.cwkCreditSheet" filter :filterFields="['code', 'name']" showClear optionLabel="code" :options="sheets.filter((s: any) => s.type == 'CWK')" placeholder="Select a Sheet" >
                                            <template #value="dropdownProps">
                                                <div v-if="dropdownProps.value" class="flex align-items-center">
                                                    <div class="row">
                                                        <span class="col-md-3">{{ dropdownProps.value.code }}</span>
                                                        <span class="col-md-9">{{ dropdownProps.value.name }}</span>
                                                    </div>
                                                </div>

                                                <span v-else>
                                                    {{ dropdownProps.placeholder }}
                                                </span>
                                            </template>

                                            <template #option="dropdownProps">
                                                <div class="row">
                                                    <span class="col-md-3">{{ dropdownProps.option.code }}</span>
                                                    <span class="col-md-9">{{ dropdownProps.option.name }}</span>
                                                </div>
                                            </template>
                                        </Dropdown>
									</div>
								</div>

                                <div class="row mb-4">
									<!-- Left half -->
									<div class="col-md-6">
										<div class="row align-items-center">
										<div class="col-md-3 required">
											<label class="col-form-label-title me-2">CWK row:</label>
										</div>
										<div class="col-md-2">
											<InputNumber placeholder="Row" v-model="eliminationSetting.cwkDebitSheetRow"/>
										</div>
										<div class="col-md-5 d-flex justify-content-end">
											<label class="col-form-label-title me-2">CWK figures in -ve?</label>
										</div>
										<div class="col-md-1 pt-1">
											<Checkbox v-model="eliminationSetting.isCwkDebitNegative" :binary="true" />
										</div>
										</div>
									</div>

									<!-- Right half -->
									<div class="col-md-6">
										<div class="row align-items-center">
										<div class="col-md-3 required">
											<label class="col-form-label-title me-2">CWK row:</label>
										</div>
										<div class="col-md-2">
											<InputNumber placeholder="Row" v-model="eliminationSetting.cwkCreditSheetRow"/>
										</div>
										<div class="col-md-5 d-flex justify-content-end">
											<label class="col-form-label-title me-2">CWK figures in -ve?</label>
										</div>
										<div class="col-md-1 pt-1">
											<Checkbox v-model="eliminationSetting.isCwkCreditNegative" :binary="true" />
										</div>
										</div>
									</div>
								</div>
								<br>

								<div class="row mb-4">
									<div class="col-md-3"></div>
												
									<div class="d-flex col-md-6">
										<Button class="p-button-sm" :disabled="v$.eliminationSetting.$invalid || isLoading" @click="identifier == null ? save() : update()" label="Save"/>
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel"/>
													
										<TheLoading v-if="isLoading"></TheLoading>
									</div>
								</div>
							</div>
						</div>
						
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>

</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router"
	import store from "@/store";
	import sheetApi from "@/api/sheet-api";
	import eliminationSettingApi from "@/api/eliminationsetting-api";
	import statusMixin from "@/mixin/status"
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	
	import useVuelidate from "@vuelidate/core"
	import { required, helpers } from "@vuelidate/validators"
    import exchangeRateMixin from "@/mixin/exchange-rate";
	
	export default defineComponent({
		mixins: [statusMixin, exchangeRateMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheLoading,
			ThePageError,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				eliminationSetting: {
					name: '',
					exchangeRate: '',
					isAssociated: true,
					rpkDebitSheet: null as any,
					rpkCreditSheet: null as any,
					cwkDebitSheet: null as any,
					cwkCreditSheet: null as any,
					cwkDebitSheetRow: null as any,
					cwkCreditSheetRow: null as any,
					isCwkDebitNegative: false,
					isCwkCreditNegative: false,
					isClosed: false},
                sheets: [] as any,
				isPageLoading: false,
				isLoading: false,
				isCompanyLoading: false,
				isDeleting: false,
			}
		},
		watch: {
			'eliminationSetting.isCwkDebitNegative'(newValue: boolean) {
				if (this.eliminationSetting.cwkDebitSheetRow != null) {
					this.eliminationSetting.cwkDebitSheetRow = newValue ? -Math.abs(this.eliminationSetting.cwkDebitSheetRow) : Math.abs(this.eliminationSetting.cwkDebitSheetRow);
				}
			},
			'eliminationSetting.cwkDebitSheetRow'(newValue: number) {
				if (newValue != null) {
					if (this.eliminationSetting.isCwkDebitNegative && newValue > 0) {
						this.eliminationSetting.isCwkDebitNegative = false;
					} else if (!this.eliminationSetting.isCwkDebitNegative && newValue < 0) {
						this.eliminationSetting.isCwkDebitNegative = true;
					}
				}
			},
			'eliminationSetting.isCwkCreditNegative'(newValue: boolean) {
				if (this.eliminationSetting.cwkCreditSheetRow != null) {
					this.eliminationSetting.cwkCreditSheetRow = newValue ? -Math.abs(this.eliminationSetting.cwkCreditSheetRow) : Math.abs(this.eliminationSetting.cwkCreditSheetRow);
				}
			},
			'eliminationSetting.cwkCreditSheetRow'(newValue: number) {
				if (newValue != null) {
					if (this.eliminationSetting.isCwkCreditNegative && newValue > 0) {
						this.eliminationSetting.isCwkCreditNegative = false;
					} else if (!this.eliminationSetting.isCwkCreditNegative && newValue < 0) {
						this.eliminationSetting.isCwkCreditNegative = true;
					}
				}
			}
		},
		computed: {
			// filterLegalGroupId() {
			// 	return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.identifier : null);
			// },
			// filterLegalGroupCode() {
			// 	return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.code : null);
			// },
		},
		mounted: function() {
			if (this.pageError == '') {
				this.isPageLoading = true;


				let r1 = sheetApi.sheetList({code: null}, '')

                let r2 = null;
				if (this.identifier != null) {
					r2 = eliminationSettingApi.eliminationSettingView(this.identifier)
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						})
				}

				Promise.all([r1, r2]).then((values: any) => {
					if (values != null) {
						for (var i = 0; i < values.length; i++) {
							if (values[i] != null) {
								if (values[i].success) {
									if (values[i].data != null) {
										if (i == 0) {
											this.sheets = values[i].data.listSet;
										}

										else if (i == 1) {
											const eliminationSetting = values[i].data.eliminationSetting;
											eliminationSetting.isCwkDebitNegative = eliminationSetting.cwkDebitSheetRow < 0;
											eliminationSetting.isCwkCreditNegative = eliminationSetting.cwkCreditSheetRow < 0;

											this.eliminationSetting = eliminationSetting;
										}
										
									}
								}
							}
						}
					}
					this.isPageLoading = false;
				})
				.catch(error => {
					this.isPageLoading = false;
					this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
				})
			}
		},
		methods: {
			save() {
				this.isLoading = true;
				eliminationSettingApi.eliminationSettingSave({
						eliminationSetting: this.eliminationSetting
					})
					.then(response => {
						store.getters.getCached.page = null;
						this.isLoading = false;
						this.$router.push("/admin/eliminationsetting");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			update() {
				this.isLoading = true;
				eliminationSettingApi.eliminationSettingUpdate({
						eliminationSetting: this.eliminationSetting
					})
					.then(response => {
						this.isLoading = false;
						this.$router.push("/admin/eliminationsetting");
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			deleteCompany() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure want to delete this elimination setting?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isDeleting = true;
						eliminationSettingApi.eliminationSettingDelete({
								eliminationSetting: this.eliminationSetting
							})
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isDeleting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.$router.push("/admin/eliminationsetting");
							})
							.catch(error => {
								this.isDeleting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				})
			},
			cancel() {
				this.$router.push("/admin/eliminationsetting");
			},
			checkRpkDebitSheetExist(dropdownItems: any) {
				if (dropdownItems != null) {
					if (this.eliminationSetting.rpkDebitSheet != null){
						if (this.eliminationSetting.rpkDebitSheet.identifier == dropdownItems.option.identifier) {
							return true;
						}
					}
				}
				return false;
			},
			checkRpkCreditSheetExist(dropdownItems : any) {
				if (dropdownItems != null) {
					if (this.eliminationSetting.rpkCreditSheet != null) {
						if (this.eliminationSetting.rpkCreditSheet.identifier == dropdownItems.option.identifier) {
							return true;
						}
					}
				}
				return false;
			},
			checkCwkDebitSheetExist(dropdownItems: any) {
				if (dropdownItems != null) {
					if (this.eliminationSetting.cwkDebitSheet != null){
						if (this.eliminationSetting.cwkDebitSheet.identifier == dropdownItems.option.identifier) {
							return true;
						}
					}
				}
				return false;
			},
			checkCwkCreditSheetExist(dropdownItems : any) {
				if (dropdownItems != null) {
					if (this.eliminationSetting.cwkCreditSheet != null) {
						if (this.eliminationSetting.cwkCreditSheet.identifier == dropdownItems.option.identifier) {
							return true;
						}
					}
				}
				return false;
			},
			notZero(value: any) {
				if (value == null || value == undefined) return true
				return value != 0
			}
		},
		setup() {
			return { v$: useVuelidate() }
		},
		validations() {
			return {
				eliminationSetting : {
					name: {
						required
					},
					exchangeRate: {
						required
					},
					rpkDebitSheet: {
						required
					},
					rpkCreditSheet: {
						required
					},
					cwkDebitSheet: {
						required
					},
					cwkCreditSheet: {
						required
					},
					cwkDebitSheetRow: {
						notZero: this.notZero,
						required
					},
					cwkCreditSheetRow: {
						notZero: this.notZero,
						required
					}
				}
			}
		}
	});
</script>
